/**
 * Hook gọi callback khi click bên ngoài phần tử ref (dropdown, menu...).
 */
import { useEffect } from 'react';

/** @param {React.RefObject} ref - Phần tử cần theo dõi vùng bên trong */
export const useClickOutside = (ref, isActive, onOutside) => {
  useEffect(() => {
    if (!isActive) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onOutside();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isActive, onOutside, ref]);
};
